import { useLocation } from "react-router-dom";
import { useIsDesktop } from "../hooks/useIsDesktop";
import DesktopOnlyBlock from "../components/DesktopOnlyBlock";
import { JSX } from "react";

interface Props {
  children: JSX.Element;
}

const MobileOnlyRoute = ({ children }: Props) => {
  const isDesktop = useIsDesktop();
  const location = useLocation();

  // const isLandingPath = ["/", "/auth"].includes(
  //   location.pathname.toLowerCase(),
  // );

  if (isDesktop) {
    return <DesktopOnlyBlock />;
  }

  return children;
};

export default MobileOnlyRoute;
